export default function DepartureStatusIcon({ status }) {
  if (status === "delayed") {
    return (
      <span className="fa-stack departure-late-icon" aria-hidden="true">
        <i className="far fa-circle fa-stack-2x"></i>
        <i className="fas fa-exclamation fa-stack-1x"></i>
      </span>
    );
  }

  const icon = status === "scheduled"
    ? "fa-calendar"
    : status === "early" ? "fa-clock" : "fa-check-circle";

  return <i className={`far ${icon}`} aria-hidden="true"></i>;
}
